import type { FeedbackMessages } from './en';

const et: FeedbackMessages = {
  qualified: {
    title: 'Täname, et vastasite sellele küsitlusele!',
    text: 'Võite brauseriakna vabalt sulgeda.\n\nLoodame Teid peagi taas näha.',
  },
  quotaFull: {
    title: 'See küsitlus on suletud',
    text: 'Täname huvi vastu meie küsitluse suhtes.\n\nKahjuks oleme juba saanud kõik vajalikud vastused.\n\nLoodame Teid näha mõnes meie tulevases küsitluses!',
  },
  terminated: {
    title: 'Täname tagasiside jagamise eest!',
    text: 'Loodame Teid peagi näha mõnes meie tulevases küsitluses. Kuni siis soovime Teile ilusat päeva.\n\nPalun sulgege see brauseriaken.',
  },
  mismatch: {
    title: 'Täname huvi vastu',
    text: 'Kahjuks ei kuulu Te selle konkreetse küsitluse sihtgruppi.\n\nVõite selle lehe sulgeda.',
  },
  error: {
    title: 'Teie taotlust ei saa täita',
    linkProblemDetailed:
      'Lingiga, mida kasutasite, on probleeme. Palun kontrollige, et aadressiribal olev link vastab Teile antud lingile, ning proovige uuesti.',
    linkProblemGeneric:
      'Lingiga, mida kasutasite, on probleeme. Palun proovige uuesti.',
    contactPerson:
      'Kui probleem püsib, palun teavitage sellest isikut, kellelt saite lingi.',
  },
};

export default et;
